import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from './types';

export const DiscIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={[0, 0, height, width].join(' ')}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 29.8332C23.3638 29.8332 29.3334 23.8636 29.3334 16.4998C29.3334 9.13604 23.3638 3.1665 16 3.1665C8.63622 3.1665 2.66669 9.13604 2.66669 16.4998C2.66669 23.8636 8.63622 29.8332 16 29.8332Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16 20.5C18.2091 20.5 20 18.7091 20 16.5C20 14.2909 18.2091 12.5 16 12.5C13.7909 12.5 12 14.2909 12 16.5C12 18.7091 13.7909 20.5 16 20.5Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};
